export default __webpack_public_path__ + "static/media/eye.c2d13d0a.svg";